// REACT IMPORTS
import DCDialLogo from "icons/DCDialLogo";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { previewDataGet } from "store/slices/paymentsSlice";
import { RootState } from "store/store";
import { decode } from "utils/HelperFunctions";
import { useTid } from "utils/testid";

/* ------------------------------------- QUESTIONS FOOTER ------------------------------------- */

const QuestionsFooter = ({ isPreview = false }: { isPreview?: boolean }) => {
  const tid = useTid();
  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);
  const { companyDetails } = useAppSelector(
    (state: RootState) => state.payment
  );
  const dispatch = useAppDispatch();

  const onGetCompanyDetails = async () => {
    try {
      let payload = {
        cluster_id: clusterId,
      };
      await dispatch(previewDataGet(payload));
    } catch (error) {
      console.log("onGetCompanyDetails error =====", error);
    }
  };

  useEffect(() => {
    if (
      (!companyDetails || Object.keys(companyDetails).length === 0) &&
      clusterId &&
      clusterId?.trim() !== ""
    ) {
      onGetCompanyDetails();
    }
  }, []);

  return (
    <div
      className={`flex justify-center ${isPreview ? "items-start" : "items-center"} gap-5 flex-col w-full`}
      data-testid={tid(
        isPreview ? "preview-questions-footer" : "questions-footer"
      )}
      aria-label="Questions footer"
    >
      <p
        className={`text-txtParagraph lg:text-base text-sm font-medium leading-normal w-full lg:text-start ${isPreview ? "text-start" : "text-center"}`}
      >
        Questions?
        <a
          className="text-blue hover:!text-btnPrimaryHover cursor-pointer"
          href={`mailto:${companyDetails?.email || ""}`}
          data-testid={tid("contact-company-link")}
          aria-label={`Contact ${
            companyDetails?.name || companyDetails?.company_name || "DCDial"
          }`}
        >
          &nbsp;Contact{" "}
          {companyDetails?.name || companyDetails?.company_name || "DCDial"}
        </a>
      </p>
      {!isPreview && (
        <div className="lg:hidden items-center flex">
          <div className="flex items-center gap-2 text-xs lg:text-base text-txtParagraph font-normal leading-normal">
            Powered by
            <DCDialLogo aria-hidden="true" />
          </div>
          <div className="h-5 w-[1px] bg-strokePrimary mx-4" />
          <div className="flex lg:gap-5 gap-3 items-center">
            <a
              target="_blank"
              rel="noreferrer"
              href={"https://www.dcdial.com/legal/terms-of-service"}
              className="text-xs lg:text-base text-txtParagraph font-normal leading-normal hover:!text-blue hover:!underline cursor-pointer"
              data-testid={tid("terms-link")}
              aria-label="Terms of service"
            >
              Terms
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href={"https://www.dcdial.com/legal/privacy-policy"}
              className="text-xs lg:text-base text-txtParagraph font-normal leading-normal hover:!text-blue hover:!underline cursor-pointer"
              data-testid={tid("privacy-link")}
              aria-label="Privacy policy"
            >
              Privacy
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionsFooter;
